<template>
    <div class="content-box mainInfo first" v-loading="dataLoading">
        <TitleTip>你只能修改部分信息，如果需要修改其余信息（比如认证信息），请联系客服</TitleTip>
        <el-form :model="formData" class="main-form sr-icon-form" ref="formData" label-position="top">
            <el-form-item class="main-info-logo" prop="logo">
                <template slot="label">
                    <svg-icon icon-class="image"></svg-icon>
                    {{ formData.idType == 1 ? '音乐人/乐队照片' : '厂牌/品牌相关照片' }}
                    <p class="tips">
                        格式JPG、JPEG、PNG，不小于400*400像素
                        <br />
                        尺寸1:1，不得大于10M
                    </p>
                </template>
                <ImageUpload
                    class="min"
                    :url.sync="formData.logo"
                    accept="image/png,image/jpeg"
                    :size="10"
                    :minWidth="400"
                    :minHeight="400"
                    :btnText="{add: '上传照片', update: '修改照片'}"
                    crop
                    :drag="false"
                    @onSuccess="handleImageSuccess"
                >
                    <div slot="tips"></div>
                </ImageUpload>
            </el-form-item>
            <el-form-item prop="upgradeEnterpriseName" v-if="formData.idType == 3" :rules="[{required: true, message: '请输入厂牌/品牌名称'}]">
                <template slot="label">
                    <svg-icon icon-class="name"></svg-icon>
                    厂牌/品牌名称
                </template>
                <el-input
                    v-model="formData.upgradeEnterpriseName"
                    :disabled="disabled"
                    :placeholder="`请输入厂牌/品牌名称`"
                    maxlength="250"
                ></el-input>
            </el-form-item>
            <el-form-item prop="name" v-else :rules="[{required: true, message: '请输入名称'}]">
                <template slot="label">
                    <svg-icon icon-class="name"></svg-icon>
                    音乐人/乐队名称
                </template>
                <el-input v-model="formData.name" :disabled="disabled" :placeholder="`请输入音乐人/乐队名称`" maxlength="250"></el-input>
            </el-form-item>
            <el-form-item v-if="formData.idType == 1" prop="citys" label="">
                <template slot="label">
                    <svg-icon icon-class="address"></svg-icon>
                    地区
                </template>
                <el-cascader style="width: 100%" v-model="formData.citys" :options="cityOptions"></el-cascader>
            </el-form-item>
            <el-form-item prop="desc">
                <template slot="label">
                    <svg-icon icon-class="intro"></svg-icon>
                    {{ formData.idType == 1 ? `音乐人/乐队简介` : `厂牌/品牌简介` }}
                </template>
                <el-input
                    v-model="formData.desc"
                    type="textarea"
                    :autosize="{minRows: 2, maxRows: 6}"
                    :placeholder="`请填写${formData.idType == 1 ? '音乐人/乐队简介' : '厂牌/品牌简介'}`"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="onSubmit" type="primary">保存信息</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';

export default {
    props: {
        albumId: {
            type: [Number, String],
            default: '',
        },
    },
    components: {ImageUpload},
    data() {
        return {
            dataLoading: false,
            formData: {
                desc: '',
            },
            cityOptions: [],
            disabled: false,
        };
    },
    mounted() {
        this.getArea();
        this.getDataDetail();
    },
    methods: {
        async getArea() {
            const response = await this.$request({
                url: '/company/restFul_op_company/view/province_info',
                method: 'GET',
            });
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.cityOptions = (result || []).map((item) => {
                const {id, name, cities = []} = item;
                return {
                    label: name,
                    value: id,
                    children: cities.map((c) => {
                        const {id, name} = c;
                        return {label: name, value: id};
                    }),
                };
            });
        },
        getDataDetail() {
            this.dataLoading = true;
            const {userType} = this.$store.state || {};
            this.$request({
                url: '/org/view/go_org_info',
                params: {type: userType == 1 ? 1 : 2},
                method: 'post',
            })
                .then((res) => {
                    const {state, msg, result} = res.data;
                    if (state == 1) {
                        if (result.identyCityCode && result.identyProvinceCode) result.citys = [result.identyProvinceCode, result.identyCityCode];
                        this.formData = result || {};
                        const {idType, name, upgradeEnterpriseName} = result || {};
                        if ((idType == 1 && name) || (idType == 3 && upgradeEnterpriseName)) this.disabled = true;
                    } else {
                        this.$message.error(msg || '获取数据失败,请重试');
                    }
                })
                .catch(() => {
                    this.$message.error('获取数据失败,请重试');
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //图片上传成功后执行 需要重置海报的水印图
        handleImageSuccess() {
            if (this.formData.logo) {
                this.$refs['formData'].clearValidate('logo');
            }
        },

        onSubmit() {
            this.$refs['formData'].validate((valid) => {
                if (valid) this.sendData();
            });
        },
        sendData() {
            this.dataLoading = true;
            const {citys, ...form} = JSON.parse(JSON.stringify(this.formData));
            const [identyProvinceCode, identyCityCode] = citys || [];

            form.identyProvinceCode = identyProvinceCode || '';
            form.identyCityCode = identyCityCode || '';

            this.$request({
                url: '/org/up/performer_org_info',
                method: 'POST',
                params: form,
            }).then((response) => {
                const {state, msg} = response.data;
                this.dataLoading = false;
                if (!state) {
                    return this.$message.error(msg);
                } else {
                    this.getDataDetail();
                    this.$store.dispatch('getUserInfo');
                    this.$message.success('更新成功');
                }
            });
        },
    },
};
</script>
<style lang="scss">
.main-info-logo {
    position: relative;
    min-height: 170px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dce0e4;
    padding-bottom: 20px;

    .el-form-item__label {
        flex: 1;

        .tips {
            font-size: 12px;
            color: $-text-400;
            line-height: 12px;
            line-height: 22px;
        }
    }
}
</style>
